import { render, staticRenderFns } from "./Categorization.vue?vue&type=template&id=6296b839&scoped=true&"
import script from "./Categorization.vue?vue&type=script&lang=js&"
export * from "./Categorization.vue?vue&type=script&lang=js&"
import style0 from "./Categorization.vue?vue&type=style&index=0&id=6296b839&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6296b839",
  null
  
)

export default component.exports